import axios from 'axios';
import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';
import { PLANT_STATUS } from '@/features/plants/schemas/plants.schema.ts';

export async function getAllBESS(): Promise<
  | {
      id: string;
      name: string;
      plantStatus: (typeof PLANT_STATUS)[number];
      mqttStatus: number;
      createdAt: string;
      updatedAt: string;
    }[]
  | undefined
> {
  try {
    const { data } = await client.get(`/bess`);

    return data.body;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(`${error?.response?.data?.message}`);
    }

    if (error instanceof Error) {
      throw new Error(`${error.message}}`);
    }
  }
}

export const useGetAllBESSQuery = ({ enabled }: { enabled?: boolean } = { enabled: true }) => {
  return useQuery({
    queryKey: ['bess'],
    queryFn: getAllBESS,
    retry: 1,
    enabled,
  });
};
